import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "lucide-react";
import { useSite, UI, resolveImg } from "@/lib/site";
import { ytId } from "@/components/CaseModal";

export const CaseCard = ({ item, onOpen, big = false, index = 0, frame = "" }) => {
  const { t } = useSite();
  const cover = Array.isArray(item?.images) ? item.images[0] : "";
  const hasVideo = !!ytId(item?.youtube);
  return (
    <motion.button
      type="button"
      onClick={() => onOpen(item)}
      data-testid={`case-card-${item.id}`}
      className="group relative block w-full overflow-hidden rounded-[22px] bg-[#171310] text-left"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.08 }}
    >
      <div className={`relative w-full overflow-hidden ${frame || (big ? "aspect-[4/5] sm:aspect-[16/10]" : "aspect-[4/3]")}`}>
        <img
          src={resolveImg(cover)}
          alt={t(item.title)}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform [transition-duration:1400ms] [transition-timing-function:cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.07]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-black/5" />
        <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-700 group-hover:opacity-100" style={{ background: "radial-gradient(60% 50% at 50% 30%, rgba(230,202,122,0.25), transparent 70%)" }} />
        <span className="absolute left-5 top-5 rounded-full border border-[#e6ca7a]/40 bg-black/30 px-3 py-1 text-[0.7rem] font-semibold tracking-widest text-[#f0d78e] backdrop-blur-md">{item.year}</span>
        <span className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-full bg-[#f0d78e] text-[#1d1712] transition-transform duration-500 group-hover:rotate-45">
          <ArrowUpRight className="h-5 w-5" />
        </span>
        <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7">
          <h3 className={`font-display font-medium leading-[1.05] text-[#fbf3e2] ${big ? "text-3xl sm:text-5xl" : "text-2xl sm:text-[1.7rem]"}`}>{t(item.title)}</h3>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-[#e2d6c0]">{t(item.text)}</p>
          <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#f0d78e]">
            {hasVideo ? <Play className="h-4 w-4 fill-current" /> : null}
            {hasVideo ? t(UI.watch) : t(UI.viewCase)}
          </span>
        </div>
      </div>
    </motion.button>
  );
};
